<template>
  <default>
    <div v-if="address" class="mx-auto p-6 space-y-6 dark:bg-gray-900 min-h-screen">
      <div class="flex justify-between items-center">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
          Adresa č. {{ address.id }}
        </h1>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Vytvořeno: {{ new Date(address.createdAt).toLocaleDateString() }}
        </span>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-4">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white border-b pb-2 dark:border-gray-700">
          Identifikační údaje
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">Firma / Jméno</p>
            <p class="text-gray-800 dark:text-gray-200 font-medium">{{ address.company || 'Nespecifikováno' }}</p>
          </div>
          <div class="flex space-x-8">
            <div v-if="address.ico">
              <p class="text-sm text-gray-500 dark:text-gray-400">IČO</p>
              <p class="text-gray-800 dark:text-gray-200 font-medium">{{ address.ico }}</p>
            </div>
            <div v-if="address.dic">
              <p class="text-sm text-gray-500 dark:text-gray-400">DIČ</p>
              <p class="text-gray-800 dark:text-gray-200 font-medium">{{ address.dic }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 border-b pb-2 dark:border-gray-700">
          Adresa
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-3">
            <p class="text-gray-800 dark:text-gray-200"><strong>Ulice:</strong> {{ address.street || '-' }}</p>
            <p class="text-gray-800 dark:text-gray-200"><strong>Město:</strong> {{ address.city || '-' }}</p>
          </div>
          <div class="space-y-3">
            <p class="text-gray-800 dark:text-gray-200"><strong>PSČ:</strong> {{ address.zip || '-' }}</p>
            <p class="text-gray-800 dark:text-gray-200"><strong>Země:</strong> {{ address.country || '-' }}</p>
          </div>
        </div>
      </div>

      <div v-if="address.custom && Object.keys(address.custom).length > 0" class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Vlastní data</h2>
        <RecursiveJson :data="address.custom" />
      </div>

      <LogsTable :entity-id="address.id" class="mt-4"/>

    </div>

    <div v-else class="mx-auto p-6 space-y-6 dark:bg-gray-900 min-h-screen animate-pulse">
      <div class="flex justify-between items-center">
        <div class="h-8 w-64 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div class="h-4 w-32 bg-gray-200 dark:bg-gray-800 rounded"></div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-4">
        <div class="h-5 w-1/4 bg-gray-300 dark:bg-gray-700 rounded mb-4"></div>
        <div class="grid grid-cols-2 gap-4">
          <div class="h-4 w-3/4 bg-gray-200 dark:bg-gray-800 rounded"></div>
          <div class="h-4 w-1/2 bg-gray-200 dark:bg-gray-800 rounded"></div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-4">
        <div class="h-5 w-1/4 bg-gray-300 dark:bg-gray-700 rounded mb-4"></div>
        <div class="grid grid-cols-2 gap-4">
          <div class="h-4 w-full bg-gray-200 dark:bg-gray-800 rounded"></div>
          <div class="h-4 w-full bg-gray-200 dark:bg-gray-800 rounded"></div>
          <div class="h-4 w-2/3 bg-gray-200 dark:bg-gray-800 rounded"></div>
          <div class="h-4 w-1/2 bg-gray-200 dark:bg-gray-800 rounded"></div>
        </div>
      </div>
    </div>
  </default>
</template>

<script lang="ts">
import Default from "@/layouts/admin/default.vue";
import {useAppStore} from "@/stores/appStore";
import RecursiveJson from "@/components/RecursiveJson.vue";
import LogsTable from "@/components/logsTable/logsTable.vue";
import {ResponseEntityAddress} from "@haxo-cz/orders-ts-client";

export default {
  name: "AddressDetailView",
  components: {LogsTable, RecursiveJson, Default},
  data() {
    return {
      address: null as ResponseEntityAddress | null,
      addressId: this.$route.params.addressId, // Ujisti se, že v routeru máš :addressId
      appStore: useAppStore(),
      loading: true,
      error: false
    }
  },
  methods: {
    fetchAddress() {
      this.loading = true;
      this.$addressesApi.findAddress(
          this.appStore.selectedProject.spaceId,
          this.appStore.selectedProject._id,
          this.addressId as string
      ).then(response => {
        // response.data by měla být přímo ResponseEntityAddress
        this.address = response.data;
      }).catch(error => {
        console.error("Chyba při načítání adresy:", error);
        this.error = true;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.fetchAddress();
  }
}
</script>